export default {
    SW_VERSION: process.env.REACT_APP_SW_VERSION
}